import { defineFrontendModule } from '~/lib/module';

defineFrontendModule({ name: 'system', owner: 'cella', scope: ['frontend'], description: 'System administration UI for platform-wide settings.' });
